let matomoUrl = [
  {
    staUrl: "https://analyticsuat.asus.com", // default
    siteId: "56",
    envUrl: "default"
  },
  {
    staUrl: "https://analytics.asus.com",
    siteId: "97",
    envUrl: "https://commercialservice.asus.com/drivercommand/" // production
  },
  {
    staUrl: "https://analyticsuat.asus.com",
    siteId: "56",
    envUrl: "https://bpza003kjc.corpnet.asus/drivercommand/" // staging
  },
  {
    staUrl: "https://analyticsuat.asus.com",
    siteId: "56",
    envUrl: "http://bpza003kjc.corpnet.asus:8081/drivercommand" // dev
  },
  {
    staUrl: "//localhost/matomo/", // local 開發環境
    siteId: "1",
    envUrl: "http://localhost:"
  }
];

export default matomoUrl;
